import type { ReactNode } from "react";

/**
 * El juego de iconos de la plantilla (ADR 0003): trazo de 2, 24x24, sin relleno
 * y heredando `currentColor`.
 *
 * Van escritos en el codigo, no como paquete ni como fuente de iconos: SPEC 3
 * prohibe librerias de UI en `web/`, y una fuente de iconos costaria ademas una
 * peticion mas y un parpadeo en cada arranque.
 */

const ICONS = {
  home: (
    <>
      <path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z"/>
    </>
  ),
  feed: (
    <>
      <rect x="3" y="4" width="18" height="7" rx="2"/>
      <rect x="3" y="14" width="18" height="7" rx="2"/>
    </>
  ),
  chart: (
    <>
      <path d="M3 3v18h18"/>
      <path d="m7 15 4-5 4 3 5-7"/>
    </>
  ),
  book: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </>
  ),
  users: (
    <>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </>
  ),
  briefcase: (
    <>
      <rect x="2" y="7" width="20" height="14" rx="2"/>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
    </>
  ),
  layers: (
    <>
      <path d="m12 2 10 6-10 6L2 8z"/>
      <path d="m2 14 10 6 10-6"/>
    </>
  ),
  settings: (
    <>
      <path d="M4 21v-7"/>
      <path d="M4 10V3"/>
      <path d="M12 21v-9"/>
      <path d="M12 8V3"/>
      <path d="M20 21v-5"/>
      <path d="M20 12V3"/>
      <path d="M1 14h6"/>
      <path d="M9 8h6"/>
      <path d="M17 16h6"/>
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4"/>
      <path d="M12 2v2"/>
      <path d="M12 20v2"/>
      <path d="m4.93 4.93 1.41 1.41"/>
      <path d="m17.66 17.66 1.41 1.41"/>
      <path d="M2 12h2"/>
      <path d="M20 12h2"/>
      <path d="m6.34 17.66-1.41 1.41"/>
      <path d="m19.07 4.93-1.41 1.41"/>
    </>
  ),
  moon: (
    <>
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="8"/>
      <path d="m21 21-4.3-4.3"/>
    </>
  ),
  plus: (
    <>
      <path d="M12 5v14"/>
      <path d="M5 12h14"/>
    </>
  ),
  x: (
    <>
      <path d="M18 6 6 18"/>
      <path d="m6 6 12 12"/>
    </>
  ),
  edit: (
    <>
      <path d="M12 20h9"/>
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>
    </>
  ),
  trash: (
    <>
      <path d="M3 6h18"/>
      <path d="M8 6V4h8v2"/>
      <path d="m19 6-1 14H6L5 6"/>
      <path d="M10 11v6"/>
      <path d="M14 11v6"/>
    </>
  ),
  camera: (
    <>
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/>
      <circle cx="12" cy="13" r="3"/>
    </>
  ),
  bookmark: (
    <>
      <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
    </>
  ),
  msg: (
    <>
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
    </>
  ),
  check: (
    <>
      <path d="M20 6 9 17l-5-5"/>
    </>
  ),
  menu: (
    <>
      <path d="M4 6h16"/>
      <path d="M4 12h16"/>
      <path d="M4 18h16"/>
    </>
  ),
  more: (
    <>
      <circle cx="12" cy="12" r="1.5"/>
      <circle cx="19" cy="12" r="1.5"/>
      <circle cx="5" cy="12" r="1.5"/>
    </>
  ),
  logout: (
    <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <path d="m16 17 5-5-5-5"/>
      <path d="M21 12H9"/>
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="10"/>
      <path d="M12 6v6l4 2"/>
    </>
  ),
  refresh: (
    <>
      <path d="M21 2v6h-6"/>
      <path d="M21 13a9 9 0 1 1-3-7.7L21 8"/>
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="13" height="13" rx="2"/>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </>
  ),
  mail: (
    <>
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="m22 7-10 7L2 7"/>
    </>
  ),
  lock: (
    <>
      <rect x="3" y="11" width="18" height="11" rx="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </>
  ),
  eye: (
    <>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
      <circle cx="12" cy="12" r="3"/>
    </>
  ),
  up: (
    <>
      <path d="M7 17 17 7"/>
      <path d="M7 7h10v10"/>
    </>
  ),
  down: (
    <>
      <path d="m7 7 10 10"/>
      <path d="M17 7v10H7"/>
    </>
  ),
  prev: (
    <>
      <path d="m15 18-6-6 6-6"/>
    </>
  ),
  next: (
    <>
      <path d="m9 18 6-6-6-6"/>
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2"/>
      <path d="M8 3v4"/>
      <path d="M16 3v4"/>
      <path d="M3 11h18"/>
    </>
  ),
  smile: (
    <>
      <circle cx="12" cy="12" r="10"/>
      <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
      <path d="M9 9h.01"/>
      <path d="M15 9h.01"/>
    </>
  ),
  hash: (
    <>
      <path d="M4 9h16"/>
      <path d="M4 15h16"/>
      <path d="M10 3 8 21"/>
      <path d="m16 3-2 18"/>
    </>
  ),
  flame: (
    <>
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.07-2.14-.22-4.05 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.15.43-2.29 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
    </>
  ),
  trend: (
    <>
      <path d="m22 7-8.5 8.5-5-5L2 17"/>
      <path d="M16 7h6v6"/>
    </>
  ),
  upload: (
    <>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <path d="m17 8-5-5-5 5"/>
      <path d="M12 3v12"/>
    </>
  ),
  library: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M8 3v14"/>
      <path d="M13 3v14"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </>
  ),
  branch: (
    <>
      <circle cx="6" cy="5" r="2.5"/>
      <circle cx="6" cy="19" r="2.5"/>
      <circle cx="18" cy="12" r="2.5"/>
      <path d="M6 7.5v9"/>
      <path d="M8.5 5H13a2.5 2.5 0 0 1 2.5 2.5V10"/>
      <path d="M8.5 19H13a2.5 2.5 0 0 0 2.5-2.5V14"/>
    </>
  ),
  shuffle: (
    <>
      <path d="M16 3h5v5"/>
      <path d="M4 20 21 3"/>
      <path d="M21 16v5h-5"/>
      <path d="m15 15 6 6"/>
      <path d="M4 4l5 5"/>
    </>
  ),
  star: (
    <>
      <path d="m12 3 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.6 9.8l6.5-.9z"/>
    </>
  ),
  image: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <circle cx="8.5" cy="8.5" r="1.5"/>
      <path d="m21 15-5-5L5 21"/>
    </>
  ),
  quote: (
    <>
      <path d="M10 11H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v8a4 4 0 0 1-4 4"/>
      <path d="M20 11h-4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v8a4 4 0 0 1-4 4"/>
    </>
  ),
  sparkles: (
    <>
      <path d="m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/>
      <path d="M18 17.5 18.8 19.7 21 20.5 18.8 21.3 18 23.5 17.2 21.3 15 20.5 17.2 19.7z"/>
    </>
  ),
} as const;

export type IconName = keyof typeof ICONS;

export function Icon(props: { name: IconName; className?: string }): ReactNode {
  return (
    <svg
      className={props.className === undefined ? "ic" : `ic ${props.className}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICONS[props.name]}
    </svg>
  );
}
